import { Box, Card, CardContent, Link, Typography } from "@mui/material";
import { PedidoRelacionado } from "../../../../../../types/api/financeiro/datalhar-titulos-receber";
import moment from "moment";
import { useModalDetalhePedido } from "../../../../../Comercial/components/ModalDetalhePedidoContext";


export default function CardPedidosRelacionados({
    pedidos
}: CardPedidosRelacionadosProps) {

    const { openModal } = useModalDetalhePedido();

    return (
        <Card>
            <CardContent>
                <Typography mb={2} fontWeight="bold" variant="h6">Pedidos relacionados</Typography>
                {
                    pedidos.map(pedido => (
                        <Box
                            key={pedido.id}
                            border={`1px dashed #1B5E20`}
                            borderRadius={1}
                            p={1}
                            mb={1}
                        >
                            <Link
                                onClick={() => openModal(pedido.codigo.toString())}
                                sx={{ display: "block", cursor: "pointer" }}
                                color="primary"
                            >
                                TECHPINES #{pedido.codigo}
                            </Link>
                            <Typography variant="subtitle2" color="text.secondary">
                                Data Pagamento: {moment(pedido.data_emissao).format("DD/MM/YYYY")}
                            </Typography>
                        </Box>
                    ))
                }
            </CardContent>
        </Card>
    )
}

interface CardPedidosRelacionadosProps {
    pedidos: PedidoRelacionado[];
}